import { Input } from 'reactstrap'

export default function OperatorInput({ index, handleChange, defaultValue }) {
  const options = []
  options.push(<option key={0} value={'C'}>Contains</option>)
  options.push(<option key={1} value={'S'}>Starts With</option>)
  options.push(<option key={2} value={'E'}>Equals</option>)

  return (
    <Input style={{ width: 'auto', display: 'inline-block' }} index={index} type="select" name="operator" className="operator-input" onChange={handleChange} defaultValue={defaultValue}>
      {options}
    </Input>
  )
}
